/* eslint-disable max-len */
import React from 'react';
function WorkOutline() {
    return (React.createElement("g", null,
        React.createElement("path", { fillRule: "evenodd", d: "M14 6V4h-4v2h4zM4 8v11h16V8H4zm16-2c1.11 0 2 .89 2 2v11c0 1.11-.89 2-2 2H4c-1.11 0-2-.89-2-2l.01-11c0-1.11.88-2 1.99-2h4V4c0-1.11.89-2 2-2h4c1.11 0 2 .89 2 2v2h4z", clipRule: "evenodd" }),
        React.createElement("path", { fill: "none", d: "M0 0h24v24H0z" })));
}
export default WorkOutline;
